// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function cancelShift(param_0) {
  return {
          TAG: /* CancelShift */0,
          _0: param_0
        };
}

function payTips(param_0) {
  return {
          TAG: /* PayTips */1,
          _0: param_0
        };
}

function setSubscriptions(param_0) {
  return {
          TAG: /* SetSubscriptions */2,
          _0: param_0
        };
}

function updateManyShifts(param_0) {
  return {
          TAG: /* UpdateManyShifts */3,
          _0: param_0
        };
}

function updatePastShifts(param_0) {
  return {
          TAG: /* UpdatePastShifts */4,
          _0: param_0
        };
}

function updateShift(param_0) {
  return {
          TAG: /* UpdateShift */5,
          _0: param_0
        };
}

function updateUpcomingShifts(param_0) {
  return {
          TAG: /* UpdateUpcomingShifts */6,
          _0: param_0
        };
}

var Dashboard = {
  cancelShift: cancelShift,
  fetchPayTipsToDos: /* FetchPayTipsToDos */0,
  fetchShifts: /* FetchShifts */1,
  payTips: payTips,
  setSubscriptions: setSubscriptions,
  startSubscriptions: /* StartSubscriptions */2,
  stopSubscriptions: /* StopSubscriptions */3,
  updateManyShifts: updateManyShifts,
  updatePastShifts: updatePastShifts,
  updateShift: updateShift,
  updateUpcomingShifts: updateUpcomingShifts
};

function addAvailableShiftStep(param_0) {
  return {
          TAG: /* AddAvailableShiftStep */0,
          _0: param_0
        };
}

function copyShiftById(param_0) {
  return {
          TAG: /* CopyShiftById */1,
          _0: param_0
        };
}

function fetchGeocodeForCopiedShift(param_0) {
  return {
          TAG: /* FetchGeocodeForCopiedShift */2,
          _0: param_0
        };
}

function setToMinimumShiftStep(param_0) {
  return {
          TAG: /* SetToMinimumShiftStep */3,
          _0: param_0
        };
}

function updateCopiedShift(param_0, param_1) {
  return {
          TAG: /* UpdateCopiedShift */4,
          _0: param_0,
          _1: param_1
        };
}

function updateNewShift(param_0) {
  return {
          TAG: /* UpdateNewShift */5,
          _0: param_0
        };
}

function updateRequestableWorkers(param_0) {
  return {
          TAG: /* UpdateRequestableWorkers */6,
          _0: param_0
        };
}

function updateSavedManagers(param_0) {
  return {
          TAG: /* UpdateSavedManagers */7,
          _0: param_0
        };
}

function updateShiftTypes(param_0) {
  return {
          TAG: /* UpdateShiftTypes */8,
          _0: param_0
        };
}

var PostAShift = {
  addAvailableShiftStep: addAvailableShiftStep,
  copyShiftById: copyShiftById,
  fetchGeocodeForCopiedShift: fetchGeocodeForCopiedShift,
  fetchRequestableWorkers: /* FetchRequestableWorkers */0,
  fetchSavedManagers: /* FetchSavedManagers */1,
  fetchShiftTypes: /* FetchShiftTypes */2,
  reset: /* Reset */3,
  setToMinimumShiftStep: setToMinimumShiftStep,
  updateCopiedShift: updateCopiedShift,
  updateNewShift: updateNewShift,
  updateRequestableWorkers: updateRequestableWorkers,
  updateSavedManagers: updateSavedManagers,
  updateShiftTypes: updateShiftTypes
};

function setCurrentDatetime(param_0) {
  return {
          TAG: /* SetCurrentDatetime */0,
          _0: param_0
        };
}

function setCurrentDatetimeInterval(param_0) {
  return {
          TAG: /* SetCurrentDatetimeInterval */1,
          _0: param_0
        };
}

var Timing = {
  setCurrentDatetime: setCurrentDatetime,
  setCurrentDatetimeInterval: setCurrentDatetimeInterval,
  startCurrentDatetimeUpdate: /* StartCurrentDatetimeUpdate */0,
  stopCurrentDatetimeUpdate: /* StopCurrentDatetimeUpdate */1
};

function addBusinessAdmin(param_0) {
  return {
          TAG: /* AddBusinessAdmin */0,
          _0: param_0
        };
}

function addBusinessLocation(param_0) {
  return {
          TAG: /* AddBusinessLocation */1,
          _0: param_0
        };
}

function addBusinessManager(param_0) {
  return {
          TAG: /* AddBusinessManager */2,
          _0: param_0
        };
}

function commentOnShift(param_0, param_1) {
  return {
          TAG: /* CommentOnShift */3,
          _0: param_0,
          _1: param_1
        };
}

function dashboard(param_0) {
  return {
          TAG: /* Dashboard */4,
          _0: param_0
        };
}

function editBusinessAdmin(param_0) {
  return {
          TAG: /* EditBusinessAdmin */5,
          _0: param_0
        };
}

function editBusinessLocation(param_0) {
  return {
          TAG: /* EditBusinessLocation */6,
          _0: param_0
        };
}

function editBusinessManager(param_0) {
  return {
          TAG: /* EditBusinessManager */7,
          _0: param_0
        };
}

function fetchEditingShift(param_0) {
  return {
          TAG: /* FetchEditingShift */8,
          _0: param_0
        };
}

function fetchSavedLocations(param_0) {
  return {
          TAG: /* FetchSavedLocations */9,
          _0: param_0
        };
}

function finishAddEditAdmin(param_0) {
  return {
          TAG: /* FinishAddEditAdmin */10,
          _0: param_0
        };
}

function finishAddEditLocation(param_0) {
  return {
          TAG: /* FinishAddEditLocation */11,
          _0: param_0
        };
}

function finishAddEditManager(param_0) {
  return {
          TAG: /* FinishAddEditManager */12,
          _0: param_0
        };
}

function finishLoginBusiness(param_0) {
  return {
          TAG: /* FinishLoginBusiness */13,
          _0: param_0
        };
}

function finishRemoveAdmin(param_0) {
  return {
          TAG: /* FinishRemoveAdmin */14,
          _0: param_0
        };
}

function finishRemoveLocation(param_0) {
  return {
          TAG: /* FinishRemoveLocation */15,
          _0: param_0
        };
}

function finishRemoveManager(param_0) {
  return {
          TAG: /* FinishRemoveManager */16,
          _0: param_0
        };
}

function loginBusiness(param_0, param_1) {
  return {
          TAG: /* LoginBusiness */17,
          _0: param_0,
          _1: param_1
        };
}

function navigateToPostAShift(param_0) {
  return {
          TAG: /* NavigateToPostAShift */18,
          _0: param_0
        };
}

function postAShift(param_0) {
  return {
          TAG: /* PostAShift */19,
          _0: param_0
        };
}

function removeBusinessAdmin(param_0) {
  return {
          TAG: /* RemoveBusinessAdmin */20,
          _0: param_0
        };
}

function removeBusinessLocation(param_0) {
  return {
          TAG: /* RemoveBusinessLocation */21,
          _0: param_0
        };
}

function removeBusinessManager(param_0) {
  return {
          TAG: /* RemoveBusinessManager */22,
          _0: param_0
        };
}

function reviewWorker(param_0, param_1) {
  return {
          TAG: /* ReviewWorker */23,
          _0: param_0,
          _1: param_1
        };
}

function setCities(param_0) {
  return {
          TAG: /* SetCities */24,
          _0: param_0
        };
}

function setUser(param_0) {
  return {
          TAG: /* SetUser */25,
          _0: param_0
        };
}

function setView(param_0) {
  return {
          TAG: /* SetView */26,
          _0: param_0
        };
}

function timing(param_0) {
  return {
          TAG: /* Timing */27,
          _0: param_0
        };
}

function updateEditingShift(param_0) {
  return {
          TAG: /* UpdateEditingShift */28,
          _0: param_0
        };
}

function updateFromUrl(param_0) {
  return {
          TAG: /* UpdateFromUrl */29,
          _0: param_0
        };
}

function updateLayout(param_0) {
  return {
          TAG: /* UpdateLayout */30,
          _0: param_0
        };
}

function updateSavedBusinessAdmins(param_0) {
  return {
          TAG: /* UpdateSavedBusinessAdmins */31,
          _0: param_0
        };
}

function updateSavedBusinessManagers(param_0) {
  return {
          TAG: /* UpdateSavedBusinessManagers */32,
          _0: param_0
        };
}

function updateSavedLocations(param_0) {
  return {
          TAG: /* UpdateSavedLocations */33,
          _0: param_0
        };
}

function updateUrl(param_0) {
  return {
          TAG: /* UpdateUrl */34,
          _0: param_0
        };
}

var fetchCities = /* FetchCities */0;

var fetchSavedBusinessAdmins = /* FetchSavedBusinessAdmins */1;

var fetchSavedBusinessManagers = /* FetchSavedBusinessManagers */2;

var fetchSavedLocationsForCurrentUser = /* FetchSavedLocationsForCurrentUser */3;

var fetchUser = /* FetchUser */4;

var logout = /* Logout */5;

var updateLayoutFromDom = /* UpdateLayoutFromDom */6;

exports.Dashboard = Dashboard;
exports.PostAShift = PostAShift;
exports.Timing = Timing;
exports.addBusinessAdmin = addBusinessAdmin;
exports.addBusinessLocation = addBusinessLocation;
exports.addBusinessManager = addBusinessManager;
exports.commentOnShift = commentOnShift;
exports.dashboard = dashboard;
exports.editBusinessAdmin = editBusinessAdmin;
exports.editBusinessLocation = editBusinessLocation;
exports.editBusinessManager = editBusinessManager;
exports.fetchCities = fetchCities;
exports.fetchEditingShift = fetchEditingShift;
exports.fetchSavedBusinessAdmins = fetchSavedBusinessAdmins;
exports.fetchSavedBusinessManagers = fetchSavedBusinessManagers;
exports.fetchSavedLocations = fetchSavedLocations;
exports.fetchSavedLocationsForCurrentUser = fetchSavedLocationsForCurrentUser;
exports.fetchUser = fetchUser;
exports.finishAddEditAdmin = finishAddEditAdmin;
exports.finishAddEditLocation = finishAddEditLocation;
exports.finishAddEditManager = finishAddEditManager;
exports.finishLoginBusiness = finishLoginBusiness;
exports.finishRemoveAdmin = finishRemoveAdmin;
exports.finishRemoveLocation = finishRemoveLocation;
exports.finishRemoveManager = finishRemoveManager;
exports.loginBusiness = loginBusiness;
exports.logout = logout;
exports.navigateToPostAShift = navigateToPostAShift;
exports.postAShift = postAShift;
exports.removeBusinessAdmin = removeBusinessAdmin;
exports.removeBusinessLocation = removeBusinessLocation;
exports.removeBusinessManager = removeBusinessManager;
exports.reviewWorker = reviewWorker;
exports.setCities = setCities;
exports.setUser = setUser;
exports.setView = setView;
exports.timing = timing;
exports.updateEditingShift = updateEditingShift;
exports.updateFromUrl = updateFromUrl;
exports.updateLayout = updateLayout;
exports.updateLayoutFromDom = updateLayoutFromDom;
exports.updateSavedBusinessAdmins = updateSavedBusinessAdmins;
exports.updateSavedBusinessManagers = updateSavedBusinessManagers;
exports.updateSavedLocations = updateSavedLocations;
exports.updateUrl = updateUrl;
/* No side effect */
